<template>
  <div class="main-video">
    <!-- controls -->
    <video
      name="media"
      id="videoId"
      webkit-playsinline="true"
      x-webkit-airplay="true"
      playsinline="true"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
      poster="../assets/poster-image.png"
      disablePictureInPicture @timeupdate="videoTimeupdate">
      <!-- https://movies-1300249927.file.myqcloud.com/media/11/17411/release/5t6AYROgxqk29922/5t6AYROgxqk29922_20220118145136_0.mp4 -->
      <source
        src="../assets/the-video.mp4"
        type="video/mp4"
      />
    </video>
    <div
      id="video-mask"
      :class="[isActive ? 'active' : '']"
      class="video-mask"
      @click="maskTriggerFn"
    >
      <function-button
        v-if="!initialed"
        :propLeft="'50%'"
        :propTop="'50%'"
        :propWidth="'10vmin'"
        :propHeight="'10vmin'"
        style="transform: translate(-50%, -50%);"
        @click.native="initApp"
      >
        <img style="width: 100%" slot="icon" src="../assets/play.svg" />
      </function-button>

      <div
        class="function-button-wrapper"
        v-if="currentScriptTag === 'begin' && isWaiting"
      >
        <function-button
          :propLeft="'28.2%'"
          :propTop="'45.3%'"
          :propWidth="'43.8%'"
          :propHeight="'7.4%'"
          @click.native="functionButtonTrigger('section_1')"
        ></function-button>
      </div>

      <div
        class="function-button-wrapper"
        v-if="currentScriptTag === 'section_1' && isWaiting"
      >
        <!-- 景观漫游 -->
        <function-button
          :propLeft="'40.5%'"
          :propTop="'10.3%'"
          :propWidth="'19.5%'"
          :propHeight="'15.4%'"
          @click.native="functionButtonTrigger('section_1_1')"
        ></function-button>

        <!-- 流程模拟 -->
        <function-button
          :propLeft="'69.5%'"
          :propTop="'41.3%'"
          :propWidth="'19.5%'"
          :propHeight="'15.4%'"
          @click.native="functionButtonTrigger('section_1_2')"
        ></function-button>

        <!-- 工艺交互 缺失 -->
        <function-button
          :propLeft="'40.5%'"
          :propTop="'73.3%'"
          :propWidth="'19.5%'"
          :propHeight="'15.4%'"
          @click.native="functionButtonTrigger('section_1_3')"
        ></function-button>

        <!-- 工艺展示 缺失-->
        <!-- <function-button
          :propLeft="'11%'"
          :propTop="'41.3%'"
          :propWidth="'19.5%'"
          :propHeight="'15.4%'"
          @click.native="functionButtonTrigger('section_1_4')"
        ></function-button> -->
      </div>

      <!-- 景观漫游 -->
      <div
        class="function-button-wrapper"
        v-if="currentScriptTag === 'section_1_1' && isWaiting"
      >
        <!-- 厂区总览 -->
        <function-button
          :propLeft="'17.5%'"
          :propTop="'41.3%'"
          :propWidth="'19.5%'"
          :propHeight="'15.4%'"
          @click.native="functionButtonTrigger('section_1_1_1')"
        ></function-button>

        <!-- 厂区漫游 -->
        <function-button
          :propLeft="'64.5%'"
          :propTop="'41.3%'"
          :propWidth="'19.5%'"
          :propHeight="'15.4%'"
          @click.native="functionButtonTrigger('section_1_1_2')"
        ></function-button>
      </div>
      <!-- 施工流程模拟 -->
      <div
        class="function-button-wrapper"
        v-if="currentScriptTag === 'section_1_2' && isWaiting"
      >
        <!-- 基坑施工 -->
        <function-button
          :propLeft="'40.5%'"
          :propTop="'13.3%'"
          :propWidth="'20%'"
          :propHeight="'22.4%'"
          @click.native="functionButtonTrigger('section_1_2_1')"
        ></function-button>

        <!-- 混凝土浇筑 -->
        <function-button
          :propLeft="'57.5%'"
          :propTop="'58.3%'"
          :propWidth="'20%'"
          :propHeight="'22.4%'"
          @click.native="functionButtonTrigger('section_1_2_2')"
        ></function-button>

        <!-- 底板以及池壁 钢筋施工 -->
        <function-button
          :propLeft="'20.5%'"
          :propTop="'58.3%'"
          :propWidth="'20%'"
          :propHeight="'22.4%'"
          @click.native="functionButtonTrigger('section_1_2_3')"
        ></function-button>
      </div>

      <!-- 工艺交互 -->
      <div
        class="function-button-wrapper"
        v-if="currentScriptTag === 'section_1_3' && isWaiting"
      >
      <!-- 粗格栅 -->
        <function-button
          :propLeft="'19.3%'"
          :propTop="'6.5%'"
          :propWidth="'33.4%'"
          :propHeight="'7.5%'"
          @click.native="functionButtonTrigger('section_1_3_1')"
        ></function-button>
        <!-- 细格栅 -->
        <function-button
          :propLeft="'19.3%'"
          :propTop="'19.1%'"
          :propWidth="'33.4%'"
          :propHeight="'7.5%'"
          @click.native="functionButtonTrigger('section_1_3_2')"
        ></function-button>
        <!-- 综合 -->
        <function-button
          :propLeft="'19.3%'"
          :propTop="'31.5%'"
          :propWidth="'33.4%'"
          :propHeight="'7.5%'"
          @click.native="functionButtonTrigger('section_1_3_3')"
        ></function-button>
        <!-- 纤维 -->
        <function-button
          :propLeft="'19.3%'"
          :propTop="'44.5%'"
          :propWidth="'33.4%'"
          :propHeight="'7.5%'"
          @click.native="functionButtonTrigger('section_1_3_4')"
        ></function-button>
        <!-- 接触 -->
        <function-button
          :propLeft="'19.3%'"
          :propTop="'57.5%'"
          :propWidth="'33.4%'"
          :propHeight="'7.5%'"
          @click.native="functionButtonTrigger('section_1_3_5')"
        ></function-button>
        <!-- 污泥 -->
        <function-button
          :propLeft="'19.3%'"
          :propTop="'71.1%'"
          :propWidth="'33.4%'"
          :propHeight="'7.5%'"
          @click.native="functionButtonTrigger('section_1_3_6')"
        ></function-button>
        <!-- 潜流 -->
        <function-button
          :propLeft="'19.3%'"
          :propTop="'84.1%'"
          :propWidth="'33.4%'"
          :propHeight="'7.5%'"
          @click.native="functionButtonTrigger('section_1_3_7')"
        ></function-button>
      </div>

      <!-- 返回 -->
      <!-- isWaiting && SCRIPTDATA[currentScriptTag] && SCRIPTDATA[currentScriptTag].pre -->
        <function-button
          v-show="isWaiting && SCRIPTDATA[currentScriptTag] && SCRIPTDATA[currentScriptTag].pre"
          :className="['success']"
          :plain="false"
          :propLeft="'5vmin'"
          :propTop="'5vmin'"
          :propWidth="'8vmin'"
          :propHeight="'8vmin'"
          @click.native="doBack()"
        >
          <img class="back-image" style="width: 70%;height: 100%;" slot="icon" src="../assets/back.svg" />
        </function-button>
    </div>
  </div>
</template>

<script>
import FunctionButton from "./FunctionButton.vue";
export default {
  components: { FunctionButton },
  name: "MainVideo",
  data() {
    return {
      initialed: false,
      videoIns: null,
      isActive: false,
      //  是否等待点击
      isWaiting: false,
      currentTime: 0,
      currentScriptTag: "begin",
      /**
       * beginTime: 片段开始时间
       * endTime: 片南段结束时间
       * resetTime: 
      */
      SCRIPTDATA: {
        //  点击此处进入施工互动展示👌
        begin: {
          beginTime: [0],
          endTime: [28],
          resetTime: [17],
          pre: null
        },
        // 景观漫游1-1 流程模拟1-2 工艺交互1-3 工艺展示1-4👌
        section_1: {
          beginTime: [32],
          endTime: [40],
          resetTime: [32],
          pre: "begin"
        },
        //  厂区总览 1-1-1 厂区漫游1-1-2👌
        section_1_1: {
          beginTime: [41],
          endTime: [52],
          resetTime: [42],
          pre: "section_1"
        },
        //  厂区总览👌
        section_1_1_1: {
          beginTime: [53],
          endTime: [1, 35],
          resetTime: [53],
          pre: "section_1_1"
        },
        //  厂区漫游👌
        section_1_1_2: {
          beginTime: [1, 36],
          endTime: [2, 40],
          resetTime: [1, 36],
          pre: "section_1_1"
        },
        //  基坑施工 1-2-1 混凝土浇筑  地板 池壁 👌
        section_1_2: {
          beginTime: [2, 42],
          endTime: [2, 55],
          resetTime: [2, 50],
          pre: "section_1"
        },
        //  基坑开挖👌
        section_1_2_1: {
          beginTime: [2, 57],
          endTime: [3, 52],
          resetTime: [2, 57],
          pre: "section_1_2"
        },
        //  混凝土浇筑
        section_1_2_2: {
          beginTime: [3, 52],
          endTime: [5, 52],
          resetTime: [3, 52],
          pre: "section_1_2"
        },
        //  底板以及池壁 钢筋施工👌
        section_1_2_3: {
          beginTime: [5, 52],
          endTime: [6, 15],
          resetTime: [5, 52],
          pre: "section_1_2"
        },
        // 工艺交互 视频为 处理流程
        section_1_3: {
          beginTime: [6, 17],
          endTime: [6, 25],
          resetTime: [6, 23],
          pre: "section_1"
        },
        //  粗格栅 细致调节
        section_1_3_1: {
          beginTime: [6, 30],
          endTime: [7, 26],
          resetTime: [6, 30],
          pre: "section_1_3"
        },
        //  细致格栅 细致调节
        section_1_3_2: {
          beginTime: [7, 27],
          endTime: [9, 4],
          resetTime: [7, 27],
          pre: "section_1_3"
        },
        //  综合生化池
        section_1_3_3: {
          beginTime: [9, 6],
          endTime: [12, 12],
          resetTime: [9, 6],
          pre: "section_1_3"
        },
        //  纤维
        section_1_3_4: {
          beginTime: [12, 13.5],
          endTime: [13, 21],
          resetTime: [12, 13.5],
          pre: "section_1_3"
        },
        //  接触
        section_1_3_5: {
          beginTime: [13, 23],
          endTime: [13, 42],
          resetTime: [13, 23],
          pre: "section_1_3"
        },
        //  污泥
        section_1_3_6: {
          beginTime: [13, 44],
          endTime: [14, 1],
          resetTime: [13, 44],
          pre: "section_1_3"
        },
        //  潜流
        section_1_3_7: {
          beginTime: [14, 3],
          endTime: [14, 30],
          resetTime: [14, 3],
          pre: "section_1_3"
        },
      },
    };
  },
  created() {},
  mounted() {
    this.videoIns = document.getElementById("videoId");
  },
  methods: {
    //  初始化
    play() {
      this.videoIns.play();
    },
    getSecondTime(v) {
      if (!v) {
        return 0;
      }
      if (!Array.isArray(v)) {
        return 0;
      }
      let res = 0;
      switch (v.length) {
        case 1:
          res = v[v.length - 1];
          break;
        case 2:
          res = v[v.length - 2] * 60 + v[v.length - 1];
          break;
        default:
          res = 0;
      }
      return res;
    },
    //  监听 video 的进度
    videoTimeupdate() {
      this.currentTime = this.videoIns.currentTime;

      const currentScriptTag = this.currentScriptTag;
      // console.log(this.currentScriptTag, "currentScriptTag");
      const currentScript = this.SCRIPTDATA[currentScriptTag];
      if (!currentScript) {
        return;
      }

      // const beginTime = this.getSecondTime(currentScript["beginTime"]);
      const endTime = this.getSecondTime(currentScript["endTime"]);
      const resetTime = this.getSecondTime(currentScript["resetTime"]);

      if (this.currentTime >= resetTime && this.currentTime <= endTime) {
        this.isWaiting = true;
      } else {
        this.isWaiting = false;
        // console.log(this.currentTime, resetTime, endTime)
        // console.log(this.currentTime > resetTime && this.currentTime <= endTime, 'A')
      }

      if (this.currentTime >= endTime - 1 && this.currentTime <= endTime) {
        // 当前片段即将结束时 重置回 resettime 暂时取消回放
        this.videoIns.currentTime = resetTime;
        // this.videoIns.pause();
      }
    },
    functionButtonTrigger(v) {
      //  v 为即将去的页面
      this.currentScriptTag = v; //this.SCRIPTDATA[v].next;
      this.videoIns.currentTime = this.getSecondTime(
        this.SCRIPTDATA[this.currentScriptTag].beginTime
      );
      //  播放
      this.videoIns.play();
    },
    //  回退
    doBack() {
      const next = this.SCRIPTDATA[this.currentScriptTag].pre;
      if(!next) { return }

      this.currentScriptTag = next;
      this.videoIns.currentTime = this.getSecondTime(this.SCRIPTDATA[next].resetTime);
      this.isWaiting = false;

      console.log(this.currentScriptTag, 'currentScriptTag');
    },
    initApp() {
      this.initialed = true;
      this.isActive = true;
      this.play();
    },
    maskTriggerFn() {
      // if (!this.initialed) {
      //   this.initialed = true;
      //   this.isActive = true;
      //   this.play();
      // this.videoIns.currentTime = 20;
      // return;
      // }
      //  不处于激活状态无法点击 只激活一次
      // if (!this.isActive) {
      //   return;
      // }
      //  是否处于循环能播放状态
      // if (!this.isWaiting) {
      //   return;
      // }
      // if (!this.currentScriptTag) {
      //   return;
      // }
      // const divWidth = e.target.offsetWidth;
      // const divHeight = e.target.offsetHeight;
      // const xPercent = e.offsetX / divWidth;
      // const yPercent = e.offsetY / divHeight;
      // console.log(xPercent, yPercent);
      // console.log(e, "e");
    },
  },
};
</script>

<style scoped>
.main-video {
  background-color: #245380;
  position: relative;

}
.main-video,
.main-video > video {
  height: 100%;
  overflow: hidden;
}
.video-mask {
  /* box-shadow: 0 0 0 1px tomato; */
  height: 100%;
  width: calc(100vh * 815 / 458);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /* background-color: gold; */
  /* opacity: .5; */
}
.video-mask.active {
  /* cursor: pointer; */
}
.function-button-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.back-image {
  transition: all .3s;
}
/* .back-image:hover {
  transform: translateX(-10px);
} */
@media screen and (min-width: 350px) and (max-width: 765px) {
  .main-video > video {
    width: 100%;
    height: initial;
    transform: translateY(30vh);
  }
  .video-mask {
    width: 100%;
    height: calc(100vw * 458 / 815);
    transform: translateX(-50%) translateY(30vh);
  }
}
</style>
